if (!customElements.get('find-gift')) {
  customElements.define(
    'find-gift',
    class FindGift extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.errorContainer = this.querySelector('.error-container');
        this.url = this.form.action;
        this.filter1 = this.querySelector('.occasion-filter');
        this.filter2 = this.querySelector('.price-filter');

        this.querySelection = [];

        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        this.filter1.addEventListener('change', this.handleOccasionChange.bind(this));
        if (this.filter2) {
          this.filter2.addEventListener('change', this.handlePriceChange.bind(this));
        }
      }

      handleFormSubmit(event) {
        event.preventDefault();

        if (!this.filter1.value && (!this.filter2 || !this.filter2.value)) {
          this.errorContainer.innerHTML = '<p>Please select any occasion or price range.</p>';
        } else {
          const querySelectionArr = this.querySelection.filter(Boolean);
          const querySelection = querySelectionArr.join('&');
          location.href = `${this.url}?${querySelection}`;
        }
      }

      handleOccasionChange(evt) {
        const value = evt.target.value;
        if (value !== '') {
          const paramName = 'filter.p.m.custom.celebration_type';
          const encodedValue = encodeURIComponent(value.trim());
          this.querySelection[0] = `${paramName}=${encodedValue}`;
        } else {
          this.querySelection[0] = undefined;
        }
      }

      handlePriceChange(evt) {
        const value = evt.target.value;
        if (value !== '') {
          const values = value.split('-');
          const paramName = 'filter.v.price';
          this.querySelection[1] = `${paramName}.gte=${values[0]}&${paramName}.lte=${values[1]}`;
        } else {
          this.querySelection[1] = undefined;
        }
      }
    }
  );
}
